import React from "react";
import { Link } from "react-router-dom";
import { ListGroup } from "reactstrap";

const Menu=()=>{
    return(
        <>
            <ListGroup>
              
              <Link tag='a' to="/" action className="list-group-item list-group-item-action">Home</Link>
              <Link tag='a' to='/add-course' action className="list-group-item list-group-item-action">Add Course</Link>
              <Link tag='a' to='/view-courses' action className="list-group-item list-group-item-action">View Courses</Link>
              <Link tag='a' to='/about-us' action className="list-group-item list-group-item-action">About Us</Link>
              <Link tag='a' to='/contact' action className="list-group-item list-group-item-action">Contact</Link>

            </ListGroup>
        
        </>
    );
}

export default Menu;